import store from '~script/store';
//登录状态检测
const loginCheck = async (to, from, next) => {
    if (store.getters.access_token) {
        if (to.name == 'login') {
            next('/')
        } else {
            next();
        }
    } else if (to.name == 'login') {
        next();
    } else {
        let locales = localStorage.getItem('locale');
        LocalStore.clearAll();
        if (locales) {
            store.commit('SET_LOCALE', locales);
        }
        next('/login');
    }
}
/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错 虽然不影响程序运行
 */
const routeReset = (Router) => {
    const originalPush = Router.prototype.push;
    Router.prototype.push = function push(location, onResolve, onReject) {
        if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
        return originalPush.call(this, location).catch((err) => err);
    };
}

export default {
    routeReset,
    loginCheck
}